/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

export const GET_REBATE_PROGRAM_DRUG = 'GET_REBATE_PROGRAM_LIST_DRUG';
export const GET_PLAN_TYPE_DATA = 'GET_PLAN_TYPE_DATA';
export const GET_ERROR_MSG_DRUG_SUMMARY = 'GET_ERROR_MSG_DRUG_SUMMARY';
export const GET_CMS_DRUG_TYPE_SUMMARY = 'GET_CMS_DRUG_TYPE_SUMMARY';
export const GET_DRUG_TYPE_DRUG_SUMMARY = 'GET_DRUG_TYPE_DRUG_SUMMARY';
export const GET_DRUG_CMS_TYPE_SUMMARY = 'GET_DRUG_CMS_TYPE_SUMMARY';
export const SELECTION_TYPE_OPTIONS = 'SELECTION_TYPE_OPTIONS';
export const DROPDOWN_UPDATED_LIST = 'DROPDOWN_UPDATED_LIST';
export const GET_FROM = 'GET_FROM';
export const SET_DISPLAY_OBJ_SUMMARY = 'SET_DISPLAY_OBJ_SUMMARY';
export const GET_PLAN_TYPE_DATA_SUMMARY = 'GET_PLAN_TYPE_DATA_SUMMARY';
export const GET_CURRENT_DISPUTE_DISPLAY_OBJ_SUMMARY =
  'GET_CURRENT_DISPUTE_DISPLAY_OBJ_SUMMARY';
export const GET_REBATE_PROGRAM_NAME_SUMMARY =
  'GET_REBATE_PROGRAM_NAME_SUMMARY';
export const SET_REFRESH_DATA_DRUG = 'SET_REFRESH_DATA_DRUG';
export const SET_REFRESH_DATA_DRUG_DISPLAY = 'SET_REFRESH_DATA_DRUG_DISPLAY';
